import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// The build puts each page's text into its HTML for search engines (see
// scripts/prerender.js). Render fresh rather than hydrate: React replaces that
// built-in HTML on load, so small differences can never break the page.
// The built-in <head> tags go too; each page adds its own as it renders.
document.querySelectorAll("[data-prerender]").forEach((node) => node.remove());
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
